export const formatResponse = response => {
  const formattedData = response.data.data.map(item => ({
    ...item,
    location: item?.city && item?.stateSlug ? `${item?.city}, ${item?.stateSlug}` : '',
    industry: item?.industry && item?.specialty ? `${item?.industry}: ${item?.specialty}` : ''
  }));

  return { ...response, data: { ...response.data, data: formattedData } };
};
